import { useQuery } from '@tanstack/react-query';

import { fetchShipmentProductClassOptions } from '../../data-provider/select-options';

export const useGetProductClass = () => {
  return useQuery({
    queryFn: fetchShipmentProductClassOptions,
    queryKey: ['shipment-product-class'],
    staleTime: Number.POSITIVE_INFINITY,
  });
};
